module.exports = {"450127100":"横州镇","450127101":"百合镇","450127102":"那阳镇","450127103":"南乡镇","450127104":"新福镇","450127105":"莲塘镇","450127106":"平马镇","450127107":"峦城镇","450127108":"六景镇","450127110":"石塘镇","450127112":"陶圩镇","450127113":"校椅镇","450127114":"云表镇","450127115":"马岭镇","450127200":"马山乡","450127203":"平朗乡","450127204":"镇龙乡","450127450":"良圻农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450127.json
// module id = 1906
// module chunks = 0